import React from 'react';
import { useTheme } from '@jira/navigation-apps__atlassian-navigation-theme/src/main.tsx';
import { NavigationSkeleton as TopNavigationSkeleton } from '@atlaskit/atlassian-navigation/skeleton-base';
import UFOLoadHold from '@atlaskit/react-ufo/load-hold';

export const JiraAtlassianNavigationSkeleton = (): React.JSX.Element => {
	const theme = useTheme();
	return (
		<UFOLoadHold name="top-navigation">
			<TopNavigationSkeleton theme={theme} />
		</UFOLoadHold>
	);
};
